import { useEntitlements } from "@/shared/entitlements/entitlements.context";
import type { Entitlements } from "@/shared/entitlements/schemas/entitlements.schema";

/// The account's seat usage (`used` / `cap`). Null `cap` means unlimited.
/// Backs the account settings seat panel and the members/invitations seat
/// cap UI (W2 / W5).
export function useSeats(): Entitlements["seats"] {
  return useEntitlements().seats;
}
